/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import React, {
    useContext,
    useState,
    useCallback,
    useEffect,
    useMemo
} from 'react';
import PropTypes from 'prop-types';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { MLGafUtil, MLNotificationBlockUtil } from 'ml-portals-util-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { MLProgressModalContext } from 'ml-portals-util-react';
import { platformMessages, translateContent } from 'ml-components-platform-react';
import { MLGAFInfoService } from 'gw-capability-quoteandbind';
import { MLGAFInfoService as GatewayMLGAFInfoService, UserService } from 'gw-capability-gateway';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLErrorMessageUtil } from 'ml-portals-util-js';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import _ from 'lodash';
import metadata from './MLEmployersAffiliationsComponent.metadata.json5';
import messages from './MLEmployersAffiliationsComponent.messages';
import styles from './MLEmployersAffiliationsComponent.module.scss';

import EmployersAffiliationsSummaryComponent from '../MLEmployersAffiliationsSummaryComponent/MLEmployersAffiliationsSummaryComponent';
import EmployersAffiliationsAccordionComponent from '../MLEmployersAffiliationsAccordionComponent/MLEmployersAffiliationsAccordionComponent';
import EmployersAffiliationsEligibilityComponent from '../MLEmployersAffiliationsEligibilityComponent/MLEmployersAffiliationsEligibilityComponent';
import EmployeeEligibilty from '../MLEmployeeEligibility/MLEmployeeEligibility';
import MLEmployersAffiliationsSummaryCard from '../MLEmployersAffiliationsSummaryCard/MLEmployersAffiliationsSummaryCard'
import EmployersAffiliationComboBoxComponent from '../MLEmployersAffiliationComboBoxComponent/MLEmployersAffiliationComboBoxComponent'
import EmployersAffiliationNonServicingStatesCardComponent from '../MLEmployersAffiliationsNonServicingStatesCard/MLEmployersAffiliationsNonServicingStatesCardComponent'
function MLEmployersAffiliationsComponent(props) {
    const {
        model,
        updateWizardData,
        setDisableNextButton,
        id,
        onValidate,
        onUpdateSearchVal,
        isPaymentScreen,
        isEndorsement,
        onVerifyEligibility,
        showErrors,
        isSkipping,
        eligibilityCheckOnInitComplete,
        isBasedOnPayroll,
        isCurrentPayPlanPayroll,
        blockOnNext,
        isModernProduct
    } = props;
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    const { authHeader } = useAuthentication();
    const { progressModalState } = useContext(MLProgressModalContext);

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const {
        addErrorAlert,
        clearAlerts,
        clearErrorAlerts,
        clearWarningAlerts,
        addWarningAlert,
        getNumberOfAlerts
    } = MLNotificationBlockUtil();

    const PC_GAF_ERROR_CODE = '5202';
    const gafPath = 'baseData.gafInfo_ML';
    const gafPathValue = 'baseData.gafInfo_ML.value';
    const isEditModePath = 'baseData.gafInfo_ML.isEditMode.value';
    const employeeInfoPath = 'baseData.employeeInfo_ML.value';
    const employeeInfo = _.get(model, employeeInfoPath, {});


    const isGpa = appConfig.portalCode === 'GPA';
    const isAmp = appConfig.portalCode === 'AMP';
    const isQnb = appConfig.portalCode === 'QB';
    const { mercerOrganization } = appConfig;
    const { mercerGpcCode } = appConfig;

    const [searchText, setSearchText] = useState('');
    const [paypoint, setPaypoint] = useState('');
    const [employerNotListed, setEmployerNotListed] = useState(false);
    const [storedSearchResults, setStoredSearchResults] = useState({});
    const [selectedCompanyData, setSelectedCompanyData] = useState('');
    const [searchByGpc, setSearchByGpc] = useState(false);
    const [groupedResults, setGroupedResults] = useState([]);
    const [eligibilityInfos, setEligibilityInfos] = useState([]);
    const [hasSearched, setHasSearched] = useState(false);
    const [showSearchInProgress, setShowSearchInProgress] = useState(false);
    const [tempResults, setTempResults] = useState(undefined);
    const [showAgentScript, setShowAgentScript] = useState(false);
    const [typeaheadTimeout, setTypeaheadTimeout] = useState(_.noop);

    //disabled from MLEmployeeEligiblity component
    const [disabledFromCheckBox, setDisabledFromCheckBox] = useState(false);

    //disabled from MLEmployersAffiliationsEligiblity component
    const [disabledFromOther, setDisabledFromOther] = useState(false);

    const quoteID = _.get(model, 'quoteID.value') || _.get(model, 'jobID.value');
    const sessionID = _.get(model, 'sessionUUID.value', undefined);
    const lastName = _.get(model, "baseData.value.primaryNamedInsured_ML.lastName", '')
    const zipCode = _.get(model, "baseData.value.mailingAddress_ML.postalCode", '')
    const gafInfo = _.get(model, `${gafPath}.value`, {})
    const primaryInsuredPath = isEndorsement ? "policyContact_ML" : "primaryNamedInsured_ML"
    const pni =  _.get(model, `baseData.value.${primaryInsuredPath}`, undefined)
    const sni = _.get(model, "baseData.value.secondaryNamedInsured_ML", undefined)
    const {isEditableVisibleForPolicyChange, validateEmployeeNumberVisibility, validateDepartmentNumberVisibility, filterEligiblity, isNonServicingState, isQnBEmployerNameDataValid } = MLGafUtil();    
    const [getFailedToUpdateGafInfo, setFailedToUpdateGafInfo] = useState(false);
    const [hideSearchForQnb, setHideSearchForQnb] = useState(!_.isEmpty(_.get(model, gafPathValue, {})?.paypointNumber));
    const [organization, setOrganization] = useState(undefined);
    const [isFromFFQ, setIsFromFFQ] = useState(false);
    

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid, model]);

    useEffect(() => {
        if(isQnb && !_.isEmpty(sessionStorage.getItem('employerName')) && _.isEmpty(_.get(model, `${gafPathValue}.gpcCode`)) &&  isQnBEmployerNameDataValid(sessionStorage.getItem('employerName'))) {
            const employerName = sessionStorage.getItem('employerName');
            const gpcStorage = sessionStorage.getItem('gpcCode');

            if(blockOnNext){
                clearErrorAlerts('qnbGPCMissing');
                addErrorAlert(messages.qnbGPCMissing,'qnbGPCMissing');
            }

            const ffqQuoteKey = quoteID || 'noQuote';

            if(sessionStorage.getItem('ffqEmployerCleared') === ffqQuoteKey) return;

            setIsFromFFQ(true);
            doSearchByGpc(gpcStorage, employerName);
        }
    }, []);

    useEffect(()=> {
        if(isGpa) {
            UserService?.getCurrentUser(authHeader)?.then((user) => {
            if (user?.primaryProducerCode_ML?.organization_ML) {
                setOrganization(user.primaryProducerCode_ML.organization_ML)
            }
        })
        }
    }, []);

    const groupGafResults = (gafResults) => {
        const resultArray = _.chain(gafResults)
            .groupBy('gpcCode')
            .toPairs()
            .map((currentItem) => {
                return _.fromPairs(_.zip(['account', 'organizations'], currentItem));
            })
            .value();
        resultArray.forEach((item) => {
            item.gpcCode = item.organizations[0].gpcCode;
            item.matchedName = item.organizations[0].accountName;
            item.companyName = item.organizations[0].companyName;
            item.customerType = item.organizations[0].customerType;
        });
        return resultArray;
    };

    const isSearchVisible = useMemo(() => {
        if (!isQnb) {
            return true;
        }
        return selectedCompanyData === "";
    }, [selectedCompanyData]);

    const isSearchVisibleQnB = useCallback(() => {
        if(!_.isEmpty(_.get(model, gafPathValue, {})?.gpcCode)){
            return false;
        }

        return selectedCompanyData === "";

    }, [hideSearchForQnb, selectedCompanyData]);

    const updateGAFInfo = useCallback(async(executeOnlyIfPreviousUpdateFailed, isReset = false, resolvePromise = null) => {
                if(isReset){
                    _.set(model, gafPathValue, {});
                }
                const gafVm = _.get(model, gafPath, {});
    
                if (gafVm?.aspects?.valid && gafVm?.aspects?.subtreeValid) {
                    if (executeOnlyIfPreviousUpdateFailed || getFailedToUpdateGafInfo) {
                        showProgressDialog(platformMessages.loading);
    
                        let res;                     
                        if (isGpa) {
                            res = await GatewayMLGAFInfoService.gpaUpdateGAFInfo(gafVm.value, quoteID, authHeader);
                        } else {
                            res = await MLGAFInfoService.updateGAFInfo(gafVm.value, sessionID, quoteID);
                        }
                        
                        hideProgressDialog(); 
                        
                        if(resolvePromise) {
                            resolvePromise();
                        }
                            
                        setFailedToUpdateGafInfo(false);
    
                        const newVm = viewModelService.clone(model);
    
                        _.set(newVm, gafPathValue, res);
                        updateWizardData(newVm);  
                    }
                } else {
                    setFailedToUpdateGafInfo(true);
                }
            }, [model, getFailedToUpdateGafInfo, showProgressDialog, isGpa, hideProgressDialog, viewModelService, updateWizardData, quoteID, authHeader, sessionID]);
        


    const handleAutoEligReset = useCallback(async(resolvePromise = null, isReset = false) => {
        if ((isQnb || isGpa) && !_.isEmpty(_.get(model,"baseData.employeeInfo_ML.value.name"))) {
        employeeInfo.gafInfo = null; 

        let resetEmployeeInfoPromise;

        if(isQnb){
            resetEmployeeInfoPromise = MLGAFInfoService.resetEmployee(
                    employeeInfo,
                    sessionID,
                    quoteID,
                    authHeader
            );
        } else if(isGpa) {            
            resetEmployeeInfoPromise = GatewayMLGAFInfoService.gpaResetEmployee(
                    employeeInfo,
                    quoteID,
                    authHeader
            );
        }
    
        showProgressDialog(platformMessages.loading, resetEmployeeInfoPromise);
    
        resetEmployeeInfoPromise?.then(() => {
            _.set(model, employeeInfoPath, {});
            _.set(model,`${employeeInfo}.name`, null);
            _.set(model, "baseData.gafInfo_ML.payrollDeductAvailable", false);
            _.set(model, "baseData.gafInfo_ML.eligibilityVerified", false);
            _.set(model, "baseData.gafInfo_ML.alternateId", null);
            _.set(model, "baseData.gafInfo_ML.ssn", null);
            _.set(model, "baseData.gafInfo_ML.last4SSN", null);
            _.set(model, 'baseData.gafInfo_ML.isEmployeeNumberAvailable.value', false);
            _.set(model, 'baseData.gafInfo_ML.isDepartmentNumberAvailable.value', false);
            _.set(model, 'baseData.gafInfo_ML.departmentNumber.value', null);
            _.set(model, 'baseData.gafInfo_ML.employeeNumber.value', null);
            _.set(model, "baseData.gafInfo_ML.employeeDepartmentNumber", null); 
            updateWizardData(model);
        }).finally(()=> updateGAFInfo(true, isReset, resolvePromise));
        } else if(isReset){
            await updateGAFInfo(true, true, resolvePromise);
        } 
    },[employeeInfo, model]);

    const selectOrganization = useCallback((selectedOrganization, isRadio = false) => {
        onUpdateSearchVal(false);
        return new Promise((resolve) => {
            if (selectedOrganization === -1) {
                setEmployerNotListed(true);
                setEligibilityInfos([]);

                handleAutoEligReset(resolve, true);
            } else {
                setEmployerNotListed(false);

                if(isQnb){
                    clearErrorAlerts('qnbGPCMissing');
                }

                let gafPromise;
                if (isGpa) {
                    gafPromise = GatewayMLGAFInfoService.gpaSelectEmployer(selectedOrganization, quoteID, authHeader);
                } else if (isEndorsement) {
                    gafPromise = MLGAFInfoService.selectEmployerForEndorsement(selectedOrganization, quoteID, authHeader);
                } else {
                    gafPromise = MLGAFInfoService.selectEmployer(selectedOrganization, sessionID, quoteID);
                }

                if (!progressModalState.active)  {
                    showProgressDialog(platformMessages.retrievingGroupAffiliationInformation, gafPromise, true);
                }
                
                gafPromise
                    .then((selectedEmployer) => {
                        setSelectedCompanyData(selectedEmployer.accountName)
                        if (selectedEmployer.gpcCode && getNumberOfAlerts('updateSearchSelection') <= 0) {
                            if (isQnb) {
                                clearWarningAlerts();
                                const errorMsg = translator(messages.qnbUpdateSearchWarning, {
                                    b: (chunks) => <strong>{chunks}</strong>
                                });
                                addWarningAlert(errorMsg, 'updateSearchSelection');
                            } else if (isGpa) {
                                clearWarningAlerts();
                                const errorMsg = translator(messages.gpaUpdateSearchWarning);
                                addWarningAlert(errorMsg, 'updateSearchSelection');
                            }
                        }

                        const customerEligInd = isQnb ? true : selectedEmployer?.customerEligibilityFileIndicator
                        const employeeNamePath = `${employeeInfoPath}.name`

                        if((customerEligInd && _.isEmpty(_.get(model, employeeNamePath, undefined)) && isRadio)){ 
                            const pniLastName = pni?.lastName;
                            const postalCode = pni?.primaryAddress?.postalCode?.substring(0,5);
                            const eligibilityPromise = isGpa ? GatewayMLGAFInfoService.gpaCheckEligibilitySSNNameZip(pniLastName, postalCode, '',  quoteID, authHeader) 
                                                             : MLGAFInfoService.checkEligibilitySSNNameZip(pniLastName, postalCode, '', sessionID,  quoteID, authHeader);
                            showProgressDialog(platformMessages.loading, eligibilityPromise);

                            eligibilityPromise.then((res)=> {    

                                if(!_.isEmpty(res?.employeeInfos)){
                                    setEligibilityInfos(res.employeeInfos);
                                }
                            })
                        }

                        const newVm = viewModelService.clone(model);

                        _.set(newVm, gafPathValue, selectedEmployer);
                        _.set(newVm, isEditModePath, true);

                        if(isRadio && !_.isEmpty(_.get(newVm,'baseData.gafInfo_ML.departmentNumber.value'))){
                            _.set(newVm, 'baseData.gafInfo_ML.departmentNumber.value', null);
                        }

                        if(isRadio && !_.isEmpty(_.get(newVm,'baseData.gafInfo_ML.employeeNumber.value'))){
                            _.set(newVm, 'baseData.gafInfo_ML.employeeNumber.value', null);
                        }

                        if(_.isEmpty(_.get(model, employeeInfoPath, undefined)?.name)) {
                            _.set(newVm, 'baseData.gafInfo_ML.isEmployeeNumberAvailable.value', false);
                            _.set(newVm, 'baseData.gafInfo_ML.isDepartmentNumberAvailable.value', false);
                        }

                        if(isQnb) {
                            if(_.isEmpty(_.get(model, employeeInfoPath, undefined)?.name)){
                                _.set(newVm, 'baseData.gafInfo_ML.last4SSN.value', "");
                            }
                            _.set(newVm, 'baseData.gafInfo_ML.isQB.value', true);

                            if(_.isEmpty(sessionStorage.getItem('isBindableGPCSelected'))) {
                                sessionStorage.setItem('isBindableGPCSelected', true);
                            }
                            
                            setHideSearchForQnb(true);
                        }

                        model.value = newVm.value;

                        setTempResults(groupedResults);
                        setGroupedResults([]);
                        updateWizardData(model);
                    }).catch(error => {
                        // US1177977: Handle CDCE Exceptions error
                        hideProgressDialog();
                        MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
                    });
                resolve();
            }
        });
    }, [addWarningAlert, authHeader, clearWarningAlerts, getNumberOfAlerts, groupedResults, isEndorsement, isGpa, isQnb, model, onUpdateSearchVal, quoteID, sessionID, showProgressDialog, translator, updateWizardData, viewModelService]);

    const showSearchResults = useCallback((searchResult, groupsRemoved, isGpcSearch = searchByGpc) => {
        let finalGroupedResult;
        if (isGpcSearch) {
            finalGroupedResult = groupGafResults(searchResult);
        } else {
            const filteredGpc = (organization?.name?.toLowerCase().includes(mercerOrganization)) ? searchResult.filter(results => results.gpcCode === mercerGpcCode) : searchResult.filter(results => results.gpcCode !== mercerGpcCode);

            finalGroupedResult = filteredGpc;
        }
        setGroupedResults(finalGroupedResult);

        if(searchResult.length === 0 && isGpa && !searchByGpc && (organization?.name?.toLowerCase().includes(mercerOrganization))) {
            clearErrorAlerts();
            addErrorAlert(translator(messages.invalidEmployerorAffiliation), 'invalidEmployerorAffiliation')
        }

        if (!!groupsRemoved && !_.isEmpty(groupsRemoved) && searchResult.length === 0) {
            const errorMsg =  translator(<FormattedMessage
                {...messages.showNoAvailableGroupError}
                values={{
                    phone: (
                        <a href={`tel:+${translator(messages.mlPhoneNumber)}`} style={{ textDecoration: 'none' }}>
                            {translator(messages.mlPhoneNumber)}
                        </a>
                    )
                }}
            />) 

            if(isQnb && getNumberOfAlerts('mlGroupAssociationsNoResultsError') <= 0) {
                clearErrorAlerts('mlGroupAssociationsNoResultsError');
                addErrorAlert(errorMsg, 'mlGroupAssociationsNoResultsError');
            } else{
                addErrorAlert(errorMsg, 'mlGroupAssociationsNoResultsError');
            } 
        } else if (finalGroupedResult.length === 0) {
            const errorMsg =  translator(<FormattedMessage
                {...messages.noResultsFound}
                values={{
                    phone: (
                        <a href={`tel:+${translator(messages.mlPhoneNumber)}`} style={{ textDecoration: 'none' }}>
                            {translator(messages.mlPhoneNumber)}
                        </a>
                    )
                }}
            />) 

            if (isGpa && !searchByGpc && (organization?.name?.toLowerCase().includes(mercerOrganization)) && searchResult.length === 0) {
                clearErrorAlerts();
                addErrorAlert(translator(messages.invalidEmployerorAffiliation), 'invalidEmployerorAffiliation')
            }
            else {
                clearErrorAlerts();
                addErrorAlert(errorMsg, 'mlGroupAssociationsNoResultsError')
            }
            // addErrorAlert(errorMsg, 'mlGroupAssociationsNoResultsError')
        } else if(isQnb && !_.isEmpty(sessionStorage.getItem('employerName'))) {
            clearWarningAlerts('qnbSelectEmployerWarning');
            addWarningAlert(messages.qnbSelectEmployerWarning, 'qnbSelectEmployerWarning');
        }
    }, [addErrorAlert, searchByGpc, translator]);

    const doSearch = useCallback(() => {
        if (_.isEmpty(searchText)) {
            return;
        }

        clearAlerts();

        let gafPromise;
        if (isGpa) {
            gafPromise = GatewayMLGAFInfoService.gpaSearchGAFInfos(searchText, quoteID, authHeader);
        } else if (isEndorsement) {
            gafPromise = MLGAFInfoService.searchGAFInfosForEndorsement(searchText, quoteID, authHeader);
        } else {
            gafPromise = MLGAFInfoService.searchGAFIInfoByName(searchText, sessionID, quoteID);
        }
        showProgressDialog(platformMessages.searchingGroupAffiliationInformation, gafPromise);
        gafPromise
            .then((searchResults) => {
                if (searchResults.gafInfos && searchResults.gafInfos.length > 100) {
                    setStoredSearchResults({ gafInfos: [] });
                    const errorMsg = translator(messages.multipleEntriesError);
                    addErrorAlert(errorMsg, 'tooManyResults')
                } else {
                    setStoredSearchResults(searchResults);
                    showSearchResults(searchResults);
                }
            }, (error) => {
                const errorCode = _.get(error, 'baseError.data.error.errorCode', '');
                const errorMessage = _.get(error, 'baseError.data.error.message');
                if (errorCode === PC_GAF_ERROR_CODE) {
                    addErrorAlert(errorMessage, 'mlGroupAssociations')
                } else {
                    const errorMsg = translator(messages.errorOccuredTryAgain);
                    addErrorAlert(errorMsg, 'mlGroupAssociationsNoResultsError');
                    const emptySearchRes = { gafInfos: [] };
                    setStoredSearchResults(emptySearchRes);
                    showSearchResults(emptySearchRes);
                }
            });
    }, [addErrorAlert, authHeader, clearAlerts, isEndorsement, isGpa, quoteID, searchText, sessionID, showProgressDialog, showSearchResults, translator]);

    const doSearchByGpc = async(gpcSearch = "", employerName = undefined) => {
        if (searchText || gpcSearch) {
            clearAlerts();

            if ((isGpa) && (searchText.length === 3) && (
                (organization?.name?.toLowerCase().includes(mercerOrganization) && searchText !== mercerGpcCode) ||
                (!organization?.name?.toLowerCase().includes(mercerOrganization) && searchText === mercerGpcCode)
            )){
                addErrorAlert(translator(messages.invalidGpc), 'invalidGpc');

                return;
            }

            const gpc = isQnb && gpcSearch? gpcSearch : searchText.toUpperCase();

            setSearchText(isQnb ? employerName : gpc);
            clearAlerts();
            setTempResults(undefined);
            setGroupedResults([]);
            setHasSearched(true);

            if((!_.isEmpty(gafInfo?.gpcCode) && !_.isNull(gafInfo?.gpcCode)) 
                || (!_.isEmpty(gafInfo?.paypointNumber) && !_.isNull(gafInfo?.paypointNumber))) {
                await selectOrganization(-1);
            }      

            let gafSearchByGpcPromise;
            if (isGpa) {
                gafSearchByGpcPromise = GatewayMLGAFInfoService.gpaSearchFilteredGAFByGPC(gpc, quoteID, paypoint, authHeader);
            } else if (isEndorsement) {
                gafSearchByGpcPromise = MLGAFInfoService.searchFilteredGAFByGPCForEndorsement(gpc, quoteID, authHeader);
            } else {
                gafSearchByGpcPromise = MLGAFInfoService.searchFilteredGAFByGPC(gpc, sessionID, quoteID);
            }
            showProgressDialog(platformMessages.searchingGroupAffiliationInformation, gafSearchByGpcPromise);
            gafSearchByGpcPromise.then((res) => {

                const gafInfos = _.filter(res.gafInfos, (gafData) => gafData.businessIndicator === true) || [];

                if (gafInfos && gafInfos.length > 0) {
                    if (isQnb) {
                        const customerType = _.toLower(_.get(gafInfos, '[0].customerType', ''));
                        const noEmployerSelected = _.isEmpty(_.get(model, `${gafPathValue}.gpcCode`));
                        const selectsFirstRegardlessOfCount = customerType === 'affinity' || customerType === 'association';

                        /*
                            - Always auto select if length of results is 1 
                            - For employer groups: Only select if count is 1 (covered by the top statement so no explicit check needed)
                            - Affinity / Association groups: Always select the first one regardless of count
                        */
                        const autoSelect = noEmployerSelected
                            && (gafInfos.length === 1 || selectsFirstRegardlessOfCount);

                        const ffqQuoteKey = quoteID || 'noQuote';
                        const alreadyAutoSelected = sessionStorage.getItem('ffqEmployerAutoSelected') === ffqQuoteKey;

                        if (autoSelect && !alreadyAutoSelected) {
                            sessionStorage.setItem('ffqEmployerAutoSelected', ffqQuoteKey);
                            selectOrganization(gafInfos[0], true);
                        } else if (!autoSelect) {
                            setStoredSearchResults(gafInfos);
                            showSearchResults(gafInfos, res.groupsRemoved, true);
                        }
                    } else {
                        setStoredSearchResults(gafInfos);
                        showSearchResults(gafInfos, res.groupsRemoved);
                    }
                } else {
                    setStoredSearchResults([]);
                    showSearchResults([], res?.groupsRemoved);
                }

            }, (error) => {

                const errorMsg = translator(<FormattedMessage
                    {...messages.noResultsFound}
                    values={{
                        phone: (
                            <a href={`tel:+${translator(messages.mlPhoneNumber)}`} style={{ textDecoration: 'none' }}>
                                {translator(messages.mlPhoneNumber)}
                            </a>
                        )
                    }}
                />) 

            if (isGpa && searchByGpc && (organization?.name?.toLowerCase().includes(mercerOrganization)) && groupedResults.length === 0) {
                clearErrorAlerts();
                addErrorAlert(translator(messages.invalidGpc), 'invalidGpc'); 
            }
            else {
                clearErrorAlerts();
                addErrorAlert(errorMsg, 'mlGroupAssociationsNoResultsError')
            }
            }
        
        )
            setShowAgentScript(false);
        }

            if ((isGpa) && (!searchText) && (organization?.name?.toLowerCase().includes(mercerOrganization))) {
                clearAlerts();
                addErrorAlert(translator(messages.invalidGpc), 'invalidGpc'); 
            }
    };

    const successfulSearch = useCallback(() => {
        const gafValue = _.get(model, gafPathValue, {});
        return employerNotListed || (!_.isEmpty(gafValue.gpcCode) && !_.isNull(gafValue.gpcCode));
    }, [model, employerNotListed]);

    const hasGaf = useCallback(() => {
        const gafValue = _.get(model, gafPathValue, {});
        return (!_.isEmpty(gafValue.gpcCode) && !_.isNull(gafValue.gpcCode));
    }, [model]);

    const isPaymentMethodPayrollDeduct = useCallback(() => {
        return isEndorsement && _.get(model, 'paymentDetails_ML.paymentMethod.value') === 'payrolldeduct_ml';
    }, [isEndorsement, model]);

    const onChangeSearchType = useCallback(() => {
        if(isQnb) return;
        setSearchText('');
        setPaypoint('');
        setSearchByGpc(!searchByGpc);
        document.getElementsByName('searchField')[0].focus();
    }, [searchByGpc]);

    const showCompanyAccordion = useCallback(() => {
        return _.get(groupedResults, 'length', 0) > 0;
    }, [groupedResults]);

    const getSearchTypeTextForHeader = () => {
        let searchTypeText = '';
        if (!searchByGpc) {
            searchTypeText = translator(messages.searchByEmployer);
        } else if (searchByGpc && isGpa) {
            searchTypeText = translator(messages.searchByGPC);
        } else if (searchByGpc && !isGpa) {
            searchTypeText = translator(messages.searchByMarketingCode);
        }
        return searchTypeText;
    };

    const getSearchTypeLinkText = () => {
        let searchTypeText = '';
        if (!searchByGpc && isGpa) {
            searchTypeText = translator(messages.searchByGPC);
        } else if (!searchByGpc && !isGpa) {
            searchTypeText = translator(messages.searchByMarketingCode);
        } else if (searchByGpc) {
            searchTypeText = translator(messages.searchByEmployerAffiliation);
        }
        return searchTypeText;
    };


    const getSearchPlaceholder = () => {
        let searchPlaceholder;
        if (searchByGpc) {
            if (isGpa) {
                searchPlaceholder = translator(messages.enter3CharacterGpc);
            } else if (isQnb) {
                searchPlaceholder = translator(messages.enter3CharacterMarketingNonOptional);
            } else {
                searchPlaceholder = translator(messages.enter3CharacterMarketing);
            }
        } else {
            searchPlaceholder = translator(messages.nameSearchPlaceholder);
        }
        return searchPlaceholder;
    };

    const highlightMatchedTerm = (searchedText, searchResult) => {
        const term = searchedText.toUpperCase();
        searchResult.forEach((result) => {
            if (result.matchedName.indexOf(term) === 0 || result.matchedName.charAt(result.matchedName.indexOf(term) - 1) === ' ') {
                result.matchedName = result.matchedName.replace(term, `<b>${term}</b>`);
            } else {
                result.matchedName = result.matchedName.replace(term, `<b>${term}</b>`);
            }
        });
    };

    const callTypeaheadSearch = useCallback(async(text) => {
        clearAlerts();
        setGroupedResults([]);
        setHasSearched(true);
        setShowSearchInProgress(true);
        setTempResults(undefined);

        if(!_.isEmpty((gafInfo?.gpcCode) && !_.isNull(gafInfo?.gpcCode)) 
            || (!_.isEmpty(gafInfo?.paypointNumber) && !_.isNull(gafInfo?.paypointNumber))) {
            await selectOrganization(-1);
        }   

        let typeaheadPromise;
        if (isGpa) {
            typeaheadPromise = GatewayMLGAFInfoService.gpaSearchGAFInfoForTypeahead(text, quoteID, authHeader);
        } else if (isEndorsement) {
            typeaheadPromise = MLGAFInfoService.searchGAFTypeaheadForEndorsement(text, quoteID, authHeader);
        } else {
            typeaheadPromise = MLGAFInfoService.searchGAFInfoForTypeahead(text, sessionID, quoteID);
        }
        typeaheadPromise.then((result) => {
            setShowSearchInProgress(false);
            if (result.searchText !== text) {
                return;
            }

            const searchResult = _.filter(result.gafInfos, (gafData) => gafData.businessIndicator === true) || [];

            if (searchResult.length && searchResult.length > 100) {
                setStoredSearchResults(undefined);
                const errorMsg = translator(messages.multipleEntriesError);
                addErrorAlert(errorMsg, 'tooManyResults');
            } else {
                MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getFormName()}_EmployerSearch`);
                setStoredSearchResults(searchResult);
                highlightMatchedTerm(text, searchResult);
                showSearchResults(searchResult, result.groupsRemoved);
            }
        }, (error) => {
            setShowSearchInProgress(false);
            setHasSearched(true);

            if (error.baseError.data.error && error.baseError.data.error.errorCode === PC_GAF_ERROR_CODE) {
                const msg = error.baseError.data.error.message;
                addErrorAlert(msg, 'mlGroupAssociations');
            } else {
                const errorMsg = translator(messages.errorOccuredTryAgain);
                addErrorAlert(errorMsg, 'mlGroupAssociationsNoResultsError');
                const emptySearchRes = { gafInfos: [] };
                setStoredSearchResults(emptySearchRes);
                showSearchResults(emptySearchRes);
            }
        });
        setShowAgentScript(false);
    }, [addErrorAlert, authHeader, clearAlerts, isEndorsement, isGpa, quoteID, sessionID, showSearchResults, translator]);

    const handleSearchFieldUpdated = useCallback((textValue) => {
        setSearchText(textValue);
        const shouldEnforceSearch = textValue.length > 0;
        onUpdateSearchVal(shouldEnforceSearch);

        if (!searchByGpc && textValue.length > 1) {
            clearTimeout(typeaheadTimeout);
            const localTypeaheadTimeout = setTimeout(() => {
                callTypeaheadSearch(textValue);
            }, 500);
            setTypeaheadTimeout(localTypeaheadTimeout);
        }
    }, [callTypeaheadSearch, onUpdateSearchVal, searchByGpc, typeaheadTimeout]);

    const removeSelection = () => {
        if(isQnb){
            sessionStorage.setItem('ffqEmployerCleared', quoteID || 'noQuote');
            setSearchText("");
        }
        selectOrganization(-1);
        setDisableNextButton(false);
        setSelectedCompanyData("");
        setHideSearchForQnb(false);
        if (tempResults && tempResults.length > 0) {
            setGroupedResults(tempResults);
            setTempResults(undefined);
        }
    };

    const getSearchTooltipContent = () => {
  if (isQnb) {
    return messages.searchTooltipContentQb;
  }
 
  return searchByGpc
    ? messages.searchByGPCTooltipContent
    : messages.searchTooltipContent;
};

    const handlePaypointSearchField = (textValue) => {
        setPaypoint(textValue)
    }

    const handleEligCheckbox = useCallback((isChecked) => {
        setDisabledFromCheckBox(!isChecked);
    },[]);

    const guardDisabledNextBtn = useCallback((disabledRequestFromOther) => {
        setDisabledFromOther(disabledRequestFromOther);
    },[]);

    useEffect(() => {
        if(setDisableNextButton) {
            setDisableNextButton(disabledFromOther || disabledFromCheckBox)
        }

    }, [disabledFromCheckBox, disabledFromOther, setDisableNextButton]);

  const selectEmployee = (res, empID = null) => {
    if (!_.isEmpty(res)) {
        _.set(model, employeeInfoPath, res);
        
        if(!_.isEmpty(res?.gafInfo)) {
            _.set(model, "baseData.gafInfo_ML.value", res?.gafInfo);
            _.set(model, "baseData.gafInfo_ML.isEditMode.value", true);
        }

        const altIdUsage = _.get(
            model,
            "baseData.gafInfo_ML.alternateIdUsage.value",
            false
        );

        
        _.set(model, "baseData.gafInfo_ML.eligibilityVerified", true);

        const gafPathMl =_.get(model, 'baseData.gafInfo_ML');
        
        if (!_.isEmpty(res.employeeNumber) && validateEmployeeNumberVisibility(gafPathMl, _.get(model,employeeInfoPath))) {
            _.set(model, 'baseData.gafInfo_ML.employeeNumber.value', res.employeeNumber);
            _.set(model, 'baseData.gafInfo_ML.isEmployeeNumberAvailable.value', true);
        }
        else {
            _.set(model, 'baseData.gafInfo_ML.isEmployeeNumberAvailable.value', false);
        }

        if (!_.isEmpty(res.departmentNumber)&& validateDepartmentNumberVisibility(gafPathMl, _.get(model,employeeInfoPath))) {
            _.set(model, 'baseData.gafInfo_ML.departmentNumber.value', res.departmentNumber);
            _.set(model, 'baseData.gafInfo_ML.isDepartmentNumberAvailable.value', true);
        }
        else {
            _.set(model, 'baseData.gafInfo_ML.isDepartmentNumberAvailable.value', false);
        }

        if(!_.isUndefined(_.get(model, `${gafPathValue}.employeeDepartmentNumberLength`))){
            _.set(model, 'baseData.gafInfo_ML.departmentNumber.value', res.departmentNumber);
            _.set(model, 'baseData.gafInfo_ML.employeeNumber.value', res.employeeNumber);

            var combinedNumber = res?.employeeNumber.concat(res?.departmentNumber)
            _.set(model, "baseData.gafInfo_ML.employeeDepartmentNumber", combinedNumber);
            _.set(model, 'baseData.gafInfo_ML.isEmployeeNumberAvailable.value', true);
            _.set(model, 'baseData.gafInfo_ML.isDepartmentNumberAvailable.value', true);
        }

        if(altIdUsage) {
            _.set(model, "baseData.gafInfo_ML.alternateId", empID);
        } else {
            _.set(model, "baseData.gafInfo_ML.last4SSN", empID);
        }

        employeeInfo.gafInfo = null; 
        updateWizardData(model);
    }
  };

  const handleAutoEligSelection = (isFromPaymentScreen = false, verifiedEmployee = null, id = null) => {
        if(isFromPaymentScreen && verifiedEmployee !== null) {
            selectEmployee(verifiedEmployee,id);
            return;
        }

        const foundEligMatch = filterEligiblity(eligibilityInfos, pni);

        if(foundEligMatch) {
            const updateEmployeeInfo = {...foundEligMatch, contactID: pni?.publicID}
            const employeeInfoPromise = MLGAFInfoService.selectEmployee(updateEmployeeInfo, sessionID,  quoteID, authHeader);

            showProgressDialog(platformMessages.loading, employeeInfoPromise);

            employeeInfoPromise?.then((res) => {
                if (!_.isEmpty(res)) {
                    selectEmployee(res);
                }
            });
        }
    }

  useEffect(() => {
    if(isQnb && ((eligibilityInfos?.length !== 0 && !isPaymentScreen) || ((isPaymentScreen && _.isEmpty(_.get(model,"baseData.employeeInfo_ML.value.name")))))) {
        handleAutoEligSelection();
    }
  },[eligibilityInfos]);
  
    const overrides = {
        searchByOptionRow: {
            visible: isQnb ? isSearchVisibleQnB() : isSearchVisible
        },
        searchFieldsContainer: {
            visible: isQnb ? isSearchVisibleQnB() : isSearchVisible,
            className: `${isQnb ? 'searchFlexQB' : 'searchFlex'} override-tooltip-width`
        },
        employersAffiliationsSummaryComponent: {
            model: _.get(model, gafPath, {}),
            employerNotListed: employerNotListed,
            visible: successfulSearch() && !isQnb,
            updateWizardData: updateWizardData,
            showErrors,
            isSkipping, 
            isEndorsement
        },
        employersAffiliationsSummaryCardComponent: {
            model: _.get(model, gafPath, {}),
            employerNotListed: employerNotListed,
            visible: successfulSearch() && isQnb,
            updateWizardData: updateWizardData,
            showErrors,
            isSkipping,
            removeSelection,
            isModernProduct,
            isPaymentScreen
        },
        searchField: {
            value: searchText,
            showOptional: !isPaymentScreen && !isQnb,
            onValueChange: handleSearchFieldUpdated,
            placeholder: getSearchPlaceholder(),
            label: getSearchTypeTextForHeader(),
            disabled: isEndorsement && (isCurrentPayPlanPayroll() ||  isBasedOnPayroll ||
            (organization?.name?.toLowerCase().includes(mercerOrganization) &&  gafInfo?.gpcCode === mercerGpcCode)
        ),
            tooltip: !isGpa ? undefined : {
                placement: "bottom",
                renderContent: () => translateContent({
                    tooltipHeader: translator(messages.searchTooltipLabel),
                    tooltipContent: translator(getSearchTooltipContent()),
                    translator
                })
            },
            className: isQnb ? 'searchInputSizeQB' : 'searchInputSize'
        },
        paypointSearchField: {
            showOptional: true,
            value: paypoint,
            placeholder: translator(messages.paypointPlaceholder),
            label: translator(messages.paypointFieldLabel),
            onValueChange: handlePaypointSearchField,
            visible: searchByGpc && searchText.length > 0 && !isQnb,
            disabled: isEndorsement && (isCurrentPayPlanPayroll() ||  isBasedOnPayroll ||
            (organization?.name?.toLowerCase().includes(mercerOrganization) &&  gafInfo?.gpcCode === mercerGpcCode)
        ),
        },
        formFieldHelpText: {
            visible: !(isEndorsement && (isCurrentPayPlanPayroll() ||  isBasedOnPayroll)) && !isQnb
        },
        removeSelectionButton: {
            visible: isGpa ? hasGaf() : false,
            type: isGpa ? 'outlined' : 'filled',
            disabled: (isEndorsement && (isCurrentPayPlanPayroll() ||  isBasedOnPayroll)) || (isEndorsement && (organization?.name?.toLowerCase().includes(mercerOrganization) &&  gafInfo?.gpcCode === mercerGpcCode)),
        },
        removeSelectionLink: {
            visible: false, //isQnb && isPaymentScreen && hasGaf(),
            content: messages.removeSelection
        },
        employersAffiliationsEligibilityComponent: {
            submissionVm: model,
            selectOrganization: selectOrganization,
            updateWizardData: updateWizardData,
            setDisableNextButton: guardDisabledNextBtn,
            isPaymentScreen,
            isGpa,
            isEndorsement,
            showErrors,
            isSkipping,
            eligibilityCheckOnInitComplete,
            isPaymentMethodPayrollDeduct: () => _.get(model, 'paymentDetails_ML.paymentMethod.value') === 'payrolldeduct_ml',
            isCurrentPayPlanPayroll,
            isBasedOnPayroll,
            handleAutoEligSelection,
            handleAutoEligReset,
            eligibilityInfos,
            organization
        },
        employeeEligibility: {
            model,
            eligibilityInfos,
            isEndorsement,
            visible: isQnb ? false : ((gafInfo?.customerEligibilityFileIndicator === true) 
                     && (!_.isEmpty(gafInfo?.gpcCode) && !_.isNull(gafInfo?.gpcCode))) && (!isEndorsement || (isEndorsement && (
                    (isEditableVisibleForPolicyChange(model, isEndorsement) || (!isEditableVisibleForPolicyChange(model, isEndorsement) && employeeInfo?.name))))),
            quoteID,
            setDisableNextButton,
            pni,
            sni,
            onEligCheckbox: handleEligCheckbox,
            isBasedOnPayroll,
            isCurrentPayPlanPayroll
        },
        prefillScriptHeader: {
            visible: isGpa
        },
        prefillScriptContainer: {
            visible: showAgentScript
        },
        searchHeader: {
            visible: !isQnb && !isPaymentScreen
        },
        searchHeaderQnb: {
            visible: isQnb && !isPaymentScreen
        },
        searchHeaderNonServicingStates: {
            visible: isQnb && !isPaymentScreen && isNonServicingState(model)
        },
        hrline2: {
            visible: false
        },
        searchButton: {
            visible: searchByGpc,
            disabled: isEndorsement && (isCurrentPayPlanPayroll() ||  isBasedOnPayroll),
        },
        changeSearchTypeLink: {
            content: getSearchTypeLinkText()
        },
        employersAffiliationsAccordion: {
            visible: showCompanyAccordion(),
            companies: groupedResults,
            gpcCode: _.get(model, `${gafPathValue}.gpcCode`),
            selectOrganization: (org) => selectOrganization(org, true),
            selectedPaypoint: _.get(model, `${gafPathValue}`),
            quoteID,
            sessionID,
            isGpa,
            isEndorsement,
            isPaymentMethodPayrollDeduct,
            searchText
        },
        employersAffiliationComboBox: {
            visible: false,
            companies: groupedResults,
            selectOrganization: (org) => selectOrganization(org, true),
            handleSearchFieldUpdated,
            quoteID,
            sessionID,
            searchText,
            isFromFFQ
        },
        employersAffiliationsNonServicingStatesCard: {
            visible: isQnb && isNonServicingState(model) && isSearchVisibleQnB() && hasSearched && (_.isEmpty(groupedResults))
        },
        searchInProgressSection: {
            visible: showSearchInProgress,
            className: isQnb ? 'qnbPadding24' : 'ml-section slim'
        },
        searchTooltipContainer: {
            visible: !isGpa,
            tooltipContent: getSearchTooltipContent(),
        },
        cantFindEmployerTooltip: {
            visible: hasSearched,
            tooltipContent : isQnb ? messages.cantFindEmployerContentQb : messages.cantFindEmployerContent
        },
    };

    const resolvers = {
        resolveComponentMap: {
            employersaffiliationssummary: EmployersAffiliationsSummaryComponent,
            employersaffiliationseligibilitycomponent: EmployersAffiliationsEligibilityComponent,
            MLEmployersAffiliationsSummaryCard,
            employeeEligibilty: EmployeeEligibilty,
            employersaffiliationsaccordioncomponent: EmployersAffiliationsAccordionComponent,
            employersaffiliationcomboboxcomponent: EmployersAffiliationComboBoxComponent,
            employersaffiliationsnonservicingstatescardcomponent: EmployersAffiliationNonServicingStatesCardComponent
        },
        resolveCallbackMap: {
            doSearch,
            onRemoveSelection: removeSelection,
            onValidate,
            onChangeSearchType,
            doSearchByGpc,
            onVerifyEligibility
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={model}
            classNameMap={styles}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            overrideProps={overrides}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
        />
    );
}

MLEmployersAffiliationsComponent.propTypes = {
    model: PropTypes.shape({}),
    updateWizardData: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    onValidate: PropTypes.func.isRequired,
    onUpdateSearchVal: PropTypes.func,
    isPaymentScreen: PropTypes.bool,
    isEndorsement: PropTypes.bool,
    onVerifyEligibility: PropTypes.bool,
    eligibilityCheckOnInitComplete : PropTypes.func,
    isBasedOnPayroll: PropTypes.bool,
    isCurrentPayPlanPayroll: PropTypes.func,
    blockOnNext: PropTypes.bool,
    isModernProduct: PropTypes.bool
};

MLEmployersAffiliationsComponent.defaultProps = {
    model: {},
    isPaymentScreen: false,
    onUpdateSearchVal: _.noop,
    onVerifyEligibility: _.noop,
    isEndorsement: false,
    eligibilityCheckOnInitComplete: _.noop,
    setDisableNextButton: () => false,
    isBasedOnPayroll: false,
    isCurrentPayPlanPayroll: _.noop,
    blockOnNext: false,
    isModernProduct: false
};

export default MLEmployersAffiliationsComponent;
